import { createPatchAPI } from '@cuemath/rest-api';
import { BASE_URL } from '../../constants/api';

const { usePatch: usePatchStudentTransferReasonUpdate } = createPatchAPI({
  getURL: studentTransferId =>
    `${BASE_URL}/students/students-teacher-transfer/${studentTransferId}`,
});

export { usePatchStudentTransferReasonUpdate };
